// third-party
import { IconMathSymbols, IconReport } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

const icons = {
    IconMathSymbols,
    IconReport
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //
const reportManagement = {
    id: 'Report Management',
    title: <FormattedMessage id="Report Management" />,
    icon: icons.IconMathSymbols,
    type: 'group',
    children: [
        {
            id: 'Formulae',
            title: <FormattedMessage id="Formulae" />,
            type: 'item',
            url: '/reports/list',
            icon: icons.IconMathSymbols,
            breadcrumbs: false
        },
        {
            id: 'Reports Generation',
            title: <FormattedMessage id="Reports Generation" />,
            type: 'item',
            url: '/reports-generation/list',
            icon: icons.IconReport,
            breadcrumbs: false,
        },
    ]
};

export default reportManagement;